import React, { useEffect, useRef } from 'react';
import { Container, Grid, Paper, Button } from '@mui/material';
import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import Cosection from '../components/Cosections';
import Scrolltop from '../components/Scrolltop';
import WhatsAppChatButton from '../components/Whatsapp';
import Carousel from '../pages/Carousel';
import Carousel1 from '../pages/Carousel1';
import Carousel2 from '../pages/Carousel2';
import './About.css';
import krinvyLogo from "../assets/images/krinvy_team1.gif";
import krinvyteam from "../assets/images/krinvy_team.gif";
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS when component mounts
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false
});

const statsData = [
    { title: "Happy Clients Served", count: "350+" },
    { title: "Countries Represented", count: "6+" },
    { title: "Designs Delivered", count: "500+" },
    { title: "Businesses Set Up", count: "200+" },
    { title: "Branding & Logo Designs Delivered", count: "150+" },
    { title: "Social Media Posts Designed", count: "3,000+" },
    { title: "Custom UI/UX Projects Completed", count: "60+" },
    { title: "Websites & E-commerce Platforms Launched", count: "50+" },
    { title: "Custom Web Apps Built", count: "15+" },
    { title: "Lines of Code Written", count: "1M+" },
];

const valuesData = [
  { 
    title: "Innovation", 
    desc: "We pioneer cutting-edge solutions, seamlessly blending creativity, technology, and data-driven strategies to keep your brand at the forefront of a competitive landscape." 
  },
  { 
    title: "Collaboration", 
    desc: "We partner closely with you, fostering open communication and teamwork to transform your vision into impactful, results-driven outcomes." 
  },
  { 
    title: "Integrity", 
    desc: "We uphold the highest standards of transparency, honesty, and ethical practices, ensuring trust and reliability in every project we undertake." 
  },
  { 
    title: "Excellence", 
    desc: "We are committed to delivering top-quality solutions, from business setup to digital marketing, ensuring every detail drives measurable success for your brand." 
  },
  { 
    title: "Client-Centricity", 
    desc: "Your success is our priority—we tailor our services to your unique needs, providing personalized support to help your business thrive globally." 
  },
  { 
    title: "Adaptability", 
    desc: "We stay agile in an ever-evolving market, offering flexible solutions that scale with your business, whether in India, the US, or beyond." 
  },
];

const servicesData = [
    { title: "Discovery", desc: "We dive deep into your brand's DNA—exploring its core values, vision, and what makes it truly unique." },
    { title: "Strategy", desc: "With insights in hand, we design a game plan that aligns with your goals, ensuring a strong foundation for success." },
    { title: "Concept", desc: "Creativity meets strategy as we develop compelling visuals and narratives that captivate your audience." },
    { title: "Execution", desc: "From cutting-edge design to seamless development, we bring your brand to life with precision and excellence." },
    { title: "Launch", desc: "This is your moment. We introduce your brand with impact, generating buzz and driving engagement." },
    { title: "Growth & Optimization", desc: "The journey doesn't end at launch. We analyze performance, refine strategies, and help your brand scale to new heights." },
];

const About = ({ showQuoteModal, setShowQuoteModal }) => {
    const navigate = useNavigate();
    const modalIntervalRef = useRef(null);

    useEffect(() => {
        // Initialize AOS
        AOS.refresh();

        // Modal handling logic
        const showModalIfNotOpen = () => {
            if (!showQuoteModal) {
                setShowQuoteModal(true);
            }
        };

        if (!showQuoteModal) {
            modalIntervalRef.current = setInterval(showModalIfNotOpen, 120000);
        }

        return () => {
            if (modalIntervalRef.current) {
                clearInterval(modalIntervalRef.current);
            }
        };
    }, [showQuoteModal, setShowQuoteModal]);

    // Additional effect to restart interval when modal closes
    useEffect(() => {
        if (!showQuoteModal && !modalIntervalRef.current) {
            modalIntervalRef.current = setInterval(() => {
                if (!showQuoteModal) {
                    setShowQuoteModal(true);
                }
            }, 120000);
        }
        
        return () => {
            if (modalIntervalRef.current) {
                clearInterval(modalIntervalRef.current);
            }
        };
    }, [showQuoteModal, setShowQuoteModal]);

    const handleCareersClick = () => {
        navigate('/careers');
    };

    return (
        <>
            <Navigation />
            <Container className="krinvy-about-page-container">
                {/* Header Section */}
                <div className="krinvy-about-page-header" data-aos="fade-up">
                    <img 
                        src={krinvyteam} 
                        alt="Krinvy Logo" 
                        className="krinvy-about-page-logo" 
                        data-aos="fade-right"
                        data-aos-delay="100"
                    />
                    <div className="krinvy-about-page-header-text" data-aos="fade-left" data-aos-delay="200">
                        <h1 className="krinvy-about-page-title">
                            Who we Are
                        </h1>
                       <p className="krinvy-about-page-subtitle">
    We are a dynamic team based in Hyderabad, dedicated to empowering startups and businesses worldwide with a one-stop solution for growth. From business setup and compliance (INDIA, US) to AI-driven automation, custom web/mobile/e-commerce development, branding, digital marketing, and ongoing support—we deliver innovative strategies and designs that drive success. Our skilled designers, developers, and AI specialists excel in creating high-impact solutions, whether it's crafting compelling logos, building intelligent systems, running data-driven campaigns, or providing expert consulting—ensuring your brand thrives in today's competitive landscape.
</p>
                    </div>
                </div>
                
                {/* Stats Section */}
                <div className="krinvy-about-page-stats-section" data-aos="fade-up">
                    <h2 className="krinvy-about-page-stats-main-title" data-aos="fade-up" data-aos-delay="100">
                        Beyond Numbers
                    </h2>
                    <h3 className="krinvy-about-page-stats-subtitle" data-aos="fade-up" data-aos-delay="150">
                        Statistical Proof of Excellence
                    </h3>
                    <Grid container spacing={4} className="krinvy-about-page-stats-grid">
                        {statsData.map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Paper 
                                    className="krinvy-about-page-stats-card" 
                                    style={{ height: '100%' }}
                                    data-aos="zoom-in"
                                    data-aos-delay={100 + (index * 50)}
                                >
                                    <h3 className="krinvy-about-page-stats-card-title">{item.title}</h3>
                                    <h2 className="krinvy-about-page-stats-card-text">{item.count}</h2>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </div>

                {/* Values Section */}
                <h2 className="krinvy-about-page-section-title" data-aos="fade-up">
                    Our Core Values
                </h2>
                <Grid container spacing={4} className="krinvy-about-page-values-grid">
                    {valuesData.map((value, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Paper 
                                className="krinvy-about-page-values-card" 
                                style={{ height: '100%' }}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <h3 className="krinvy-about-page-values-card-title">{value.title}</h3>
                                <p className="krinvy-about-page-values-card-text">{value.desc}</p>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                {/* Team Logo */}
                <img 
                    src={krinvyLogo} 
                    alt="Krinvy Logo" 
                    className="krinvy-about-page-team-logo" 
                    data-aos="zoom-in"
                />
                
                {/* Approach Section */}
                <h2 className="krinvy-about-page-approach-title" data-aos="fade-up">
                    Our Approach: Turning Ideas into Impact
                </h2>
                <div className="krinvy-about-page-services-grid">
                    {servicesData.map((service, index) => (
                        <div 
                            key={index} 
                            className="krinvy-about-page-service-card"
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <h3 className="krinvy-about-page-service-title">{service.title}</h3>
                            <p className="krinvy-about-page-service-desc">{service.desc}</p>
                        </div>
                    ))}
                </div>
                
                {/* Carousels */}
                <div data-aos="fade-up">
                    <Carousel />
                </div>
                <div data-aos="fade-up" data-aos-delay="100">
                    <Carousel1 />
                </div>
                <div data-aos="fade-up" data-aos-delay="200">
                    <Carousel2 />
                </div>
                
                {/* Careers Section */}
                <h2 className="krinvy-about-page-careers-title" data-aos="fade-up">
                    Join Our Team
                </h2>
                <p className="krinvy-about-page-careers-text" data-aos="fade-up" data-aos-delay="100">
                    This could be your opportunity! Explore open positions and grow with us.
                </p>
                <div 
                    style={{ display: 'flex', justifyContent: 'center', marginBottom: '50px' }}
                    data-aos="fade-up" 
                    data-aos-delay="200"
                >
                    <Button 
                        variant="contained" 
                        className="krinvy-about-page-careers-button"
                        onClick={handleCareersClick}
                    >
                        View Open Positions
                    </Button>
                </div>
            </Container>
            <Scrolltop />
            <WhatsAppChatButton />
            <Cosection setShowQuoteModal={setShowQuoteModal} />
            <Footer />
        </>
    );
};

export default About;